<template lang="pug">
  router-link.product-teaser-link(
    :to="route"
    @mouseover.native="hover"
    @mouseleave.native="blur"
  )
    .product-teaser(:style="style" ref="container")
      .card-teaser.grid.rounded(v-if="display === 'card'" :class="{ hover: mouseover }")
        Picture.rounded.rounded-b-none.overflow-hidden(
          v-if="image"
          :show-spinner="false"
          :image="image"
          :lazy="true"
          :optimize="optimize"
          :ignore-container-padding="true"
          :show-matching-background="true"
          missing-icon="exclamation-triangle"
          object-fit="contain"
          fit="fit"
          :title="teaser.name"
        )
        .placeholder.rounded.rounded-b-none(v-else)
          svg
            line(x1="0" y1="100%" x2="100%" y2="0")
            line(x1="0" y1="0" x2="100%" y2="100%")
        .info-container.flex.relative
          .add-to-cart(v-if="possibleConfigurations === 1")
            button.button.is-rounded.is-danger(@click.stop.prevent="addToCart" :disabled="fetching")
              span.icon.is-medium
                i.fas.fa-shopping-cart
          .details-button(v-else)
            button.button.is-rounded.is-info
              span.icon.is-medium
                i.fas.fa-question
          .info.flex.flex-col.px-4.py-2
            .name.text-lg.primary-color(v-line-clamp:18="1") {{ teaser.name }}
            .description.text-xs(v-if="teaser.description" v-line-clamp:12="clamp")
              p.content(v-html="striptags(teaser.description)")
            .properties(v-if="properties.length")
              TeaserProperty(v-for="property in properties" :property="property" :key="property.key")
            .price.text-lg.text-right.font-normal
              //- nobr.secondary-color {{ price }}
              nobr.secondary-color(:class="{ strikethrough: salePrice }") {{ price }}
              nobr.sale(v-if="salePrice") {{ salePrice }}
        //- .rating(v-if="ratings && ratings.length")
        //-   StarRating(
        //-     :rating="rating"
        //-     :increment="0.1"
        //-     :read-only="true"
        //-     :show-rating="false"
        //-     :max-rating="stars"
        //-     :star-size="16"
        //-     :inline="true"
        //-   )
        //-   // .average {{ rating }}
        //-   // .raters ({{ ratings.length }})
        //-   .comments(v-if="comments.length")
        //-     span {{ comments.length }}
        //-     i.far.fa-comment
        //- p.category.is-uppercase.has-text-primary.has-text-weight-bold(v-if="category")
        //-     | {{ category }}
        //- h3.is-size-4(v-if="name" v-line-clamp:31="1")
        //-     | {{ name }}
        //- .bait
        //-     div(v-if="description" v-line-clamp:24="clamp")
        //-       p.content(v-html="striptags(description)")
        //- .bottom-line
        //-     .op
        //-         template(v-if="op")
        //-             | von
        //-             span {{ op }}
        //-     .link
        //-         router-link(:to="route") mehr ...
      .row-teaser.rounded(v-else-if="display === 'row'" :class="{ hover: mouseover }")
        Picture(
          v-if="image"
          :show-spinner="false"
          :image="image"
          :lazy="true"
          :optimize="optimize"
          missing-icon="exclamation-triangle"
          fit="fit"
          :title="teaser.name"
        )
        .placeholder.rounded.rounded-b-none(v-else)
          svg
            line(x1="0" y1="100%" x2="100%" y2="0")
            line(x1="0" y1="0" x2="100%" y2="100%")
        .info
          .name.text-lg.primary-color(v-line-clamp:18="2") {{ teaser.name }}
          .description.mt-1(v-if="teaser.description" v-line-clamp:12="3")
            p.content(v-html="striptags(teaser.description)")
          .properties.mt-3(v-if="properties.length")
            TeaserProperty(v-for="property in properties" :property="property" show-label :key="property.key")
          .price.text-lg.font-normal
            //- nobr.secondary-color {{ price }}
            nobr.secondary-color(:class="{ strikethrough: salePrice }") {{ price }}
            nobr.sale(v-if="salePrice") {{ salePrice }}
          .add-to-cart(v-if="possibleConfigurations === 1")
            button.button.is-danger.has-icon(@click.stop.prevent="addToCart" :disabled="fetching")
              span.icon.is-medium
                i.fas.fa-shopping-cart
              span Zum Warenkorb hinzufügen
          .details-button(v-else)
            button.button.is-info.has-icon
              span.icon.is-medium
                i.fas.fa-question
              span Details
      .tile-teaser.rounded(v-else :class="{ hover: mouseover }")
        Picture.rounded.rounded-b-none(
          v-if="image"
          :show-spinner="false"
          :image="image"
          :lazy="true"
          :optimize="optimize"
          missing-icon="exclamation-triangle"
          object-fit="contain"
          fit="fit"
          :title="teaser.name"
        )
        .placeholder.rounded.rounded-b-none(v-else)
          svg(v-if="!image || loading === false")
            line(x1="0" y1="100%" x2="100%" y2="0")
            line(x1="0" y1="0" x2="100%" y2="100%")
        .info-container.relative
          .add-to-cart(v-if="possibleConfigurations === 1")
            button.button.is-rounded.is-danger(@click.stop.prevent="addToCart" :disabled="fetching")
              span.icon.is-medium
                i.fas.fa-shopping-cart
          .details-button(v-else)
            button.button.is-rounded.is-info
              span.icon.is-medium
                i.fas.fa-question
          .info.rounded.rounded-t-none.px-4.py-2
            .name.text-lg.primary-color(v-line-clamp:18="mouseover ? 3 : 1") {{ teaser.name }}
            transition(name="slide-fade")
              template(v-if="mouseover")
                .hidden-info
                  .description.text-xs(v-if="teaser.description" v-line-clamp:12="6")
                    p.content(v-html="striptags(teaser.description)")
                  .properties(v-if="properties.length")
                    TeaserProperty(v-for="property in properties" :property="property" :key="property.key")
            .price.text-lg.text-right.font-normal
              //- nobr.secondary-color {{ price }}
              nobr.secondary-color(:class="{ strikethrough: salePrice }") {{ price }}
              nobr.sale(v-if="salePrice") {{ salePrice }}
</template>

<script>
import uniqid from 'uniqid';
import { mapGetters, mapActions } from 'vuex';
import striptags from 'striptags';
// import VanillaTilt from 'vanilla-tilt';

import { get, trim, debounce } from '@/helpers';
import { getPropertyValues } from '@/extensions/shop/helpers';
import { moneyFormat } from '@/filters';

import TeaserProperty from './TeaserProperty';

export default {
  name: 'Teaser',
  data() {
    return {
      delay: 150,
      mouseover: false,
      loaded: false,
      loading: true,
      fetching: false,
      error: false
      // stars: 5,
    };
  },
  props: {
    teaser: {
      type: Object,
      required: true
    },
    display: {
      type: String,
      default: 'card',
      validator: val => ['row', 'card', 'tile'].includes(val)
    },
    optimize: {
      // if speed is selected, get only prerendered variants if possible
      type: String,
      default: 'traffic',
      validator: val => ['speed', 'traffic'].includes(val)
    }
  },
  components: {
    TeaserProperty
  },
  computed: {
    route() {
      return {
        name: 'product-details',
        params: {
          product: this.teaser.slug
        }
      };
    },
    price() {
      const price = this.teaser.price;
      const customerGroup = price.customerGroup || get(this.cms, 'shop.defaultCustomerGroup');
      const code = get(customerGroup, 'currency.iso4217') || 'EUR';

      return moneyFormat(price.value, code);
    },
    salePrice() {
      if (!this.teaser.salePrice) return null;

      const price = this.teaser.salePrice;
      const customerGroup = price.customerGroup || get(this.cms, 'shop.defaultCustomerGroup');
      const code = get(customerGroup, 'currency.iso4217') || 'EUR';

      return moneyFormat(price.value, code);
    },
    properties() {
      const properties = [];
      const propertyPivots = this.teaser.propertyPivots || [];

      propertyPivots.forEach(propertyPivot => {
        if (propertyPivot.property.visible_on_product_listing === true) {
          const values = propertyPivot.values.map(el => {
            return {
              value: el[propertyPivot.property.propType.value_field],
              value_alt: el[propertyPivot.property.propType.value_field_alt]
            };
          });
          properties.push({
            key: propertyPivot.property.key,
            name: propertyPivot.property.name,
            type: propertyPivot.property.propType.key,
            values
          });
        }
      });

      return properties;
    },
    possibleConfigurations() {
      let numberOfConfigurations = 1;
      const propertyPivots = this.teaser.propertyPivots || [];
      propertyPivots.forEach(pivot => {
        const el = getPropertyValues(pivot);
        numberOfConfigurations *= el?.values?.length || 1;
      });
      return numberOfConfigurations;
    },
    image() {
      let image;

      if (this.teaser.media && this.teaser.media.type === 'image' && typeof this.teaser.media.image === 'object') {
        image = this.teaser.media.image;
      }

      return image;
    },
    style() {
      let style;
      if (this.display === 'tile' && this.teaser.style) {
        style = {
          position: 'absolute',
          display: 'flex',
          left: `${this.teaser.style.left}px`,
          top: `${this.teaser.style.top}px`,
          width: `${this.teaser.style.width}px`,
          height: `${this.teaser.style.height}px`
        };
      }
      return style;
    },
    clamp() {
      let clamp = 3;
      if (this.ratings && this.ratings.length) clamp = 2;
      return clamp;
    },
    ...mapGetters({
      cms: 'CMS'
    })
  },
  methods: {
    hover() {
      this.$emit('focus', this.item);
      this.mouseover = true;
    },
    blur() {
      setTimeout(() => {
        this.$emit('blur', this.item);
        this.mouseover = false;
      }, this.delay);
    },
    striptags(html) {
      html = html.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '<br />');
      return striptags(html, ['a', 'i', 'u', 'b', 'em', 'strong', 'span', 'br']);
    },
    addToCart() {
      // TODO:
      // get articles by product id
      // if there is only one article
      // then add to cart, otherwise open details

      this.fetching = true;
      this.fetchProduct({ id: parseInt(this.teaser.id) })
        .then(product => {
          if (product?.articles?.length === 1) {
            const article = product.articles[0];
            try {
              this.addArticleToCart({ article, qty: 1 });

              const text = `
                <p>Der folgende Artikel wurde Ihrem Warenkorb hinzugefügt</p>
                <blockquote class="mt-2 pl-3 border-l-2 border-white border-opacity-50">
                  <h4 class="text-xl leading-none mb-1">${article.name || product.name}</h4>
                  <p class="text-xs mb-2 text-white text-opacity-75">#${product.nr}</p>
                  <p>Preis: ${this.salePrice || this.price}</p>
                </blockquote>
              `;

              const message = {
                id: uniqid(),
                text,
                type: 'success',
                autoclose: 4000
              };
              this.addMessage(message);
            } catch (e) {
              const errorMessage = {
                id: uniqid(),
                title: 'Fehler',
                text: 'Es gibt ein technisches Problem.',
                type: 'error',
                autoclose: 8000
              };
              this.addMessage(errorMessage);
              this.$router.push(this.route);
            }
          } else {
            this.$router.push(this.route);
          }
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    ...mapActions({
      addMessage: 'message/add',
      addArticleToCart: 'shop/addArticleToCart',
      fetchProduct: 'shop/fetchProduct'
    })
  }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

a.product-teaser-link
  text-decoration: none

.card-teaser, .tile-teaser, .row-teaser
  background-color: $white
  width: 100%
  transition: transform .3s cubic-bezier(0, 0.9, 0.31, 1.04)
  &:after
    @apply rounded
    content: ''
    position: absolute
    top: 0
    left: 0
    height: 100%
    width: 100%
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)
    z-index: -1
    transform: translateZ(-50px)
    transition: .3s cubic-bezier(0, 0.9, 0.31, 1.04)
  .placeholder
    padding-bottom: 100%
    position: relative
    svg
      width: calc(100% - 1rem)
      height: calc(100% - 1rem)
      position: absolute
      top: 0.5rem
      left: 0.5rem
      line
        stroke: rgba($red, .3)
        stroke-width: 1.02
  .info
    // height: 135px
    overflow-x: hidden
    width: 100%
    .name, .description
      line-height: 1.3
      word-break: normal !important
  .description
    font-size: .85rem
    @screen sm
      font-size: 1rem
  .price
    @apply mt-1
    @screen sm
      @apply mt-3
  .text-lg
    font-size: 1.15rem
    @screen sm
      @apply text-lg

.card-teaser
  .description,
  .properties
    margin-top: 0.5rem
  .price
    padding-top: 0.5rem
    margin-top: auto

.tile-teaser
  .info-container
    background-color: $white
    width: 100%
    height: auto
    position: absolute
    bottom: 0
    .properties
      margin-top: 0.5rem
    .content
      margin-top: 0.5rem
      &::v-deep
        br + br
          display: none

.card-teaser, .tile-teaser
  ::v-deep .property
    @apply mb-1
    .values
      margin-left: -2px
      height: 22px
      overflow-y: hidden
      overflow-x: scroll
      scrollbar-width: none
      -ms-overflow-style: none
      &::-webkit-scrollbar
        display: none

.row-teaser
  display: grid
  margin-bottom: 1rem
  background-color: transparent
  transition: transform .3s cubic-bezier(0, 0.9, 0.31, 1.04), background-color .3s cubic-bezier(0, 0.9, 0.31, 1.04)
  grid-template-columns: 80px auto
  @screen sm
    grid-template-columns: 140px auto
  @screen md
    grid-template-columns: calc(180px + 2rem) auto
  &:after
    box-shadow: none
  .picture-container
    display: flex
    align-items: center
    justify-content: center
    padding: 0
    width: 80px
    height: auto
    @screen sm
      width: 140px
    @screen md
      min-height: calc(100px + 2rem)
      width: calc(180px + 2rem)
      padding: 1rem
    &::v-deep
      .info,
      figure img,
      figure picture
        @apply rounded
  .info
    @apply px-2 py-1
    display: flex
    flex-direction: column
    justify-content: center
    @screen sm
      @apply px-4 py-3
    @screen md
      @apply px-4 py-6
  ::v-deep .property
    @apply mb-3

.product-teaser
  // transform-style: preserve-3d
  will-change: transform
  // .name, .description, .price
  //   transform: translateZ(50px) scale(1)

.card-teaser, .tile-teaser
  .details-button,
  .add-to-cart
    position: absolute
    right: 0.5rem
    top: -1.8rem
    z-index: 1
    transform: scale(0.8)
    transition: opacity .15s ease, transform .15s cubic-bezier(0, 0.9, 0.31, 1.04)
    @screen md
      right: 0.8rem
      opacity: 0
    button
      padding-left: 0.4rem
      padding-right: 0.4rem
      min-width: 40px
      height: 40px
      svg
        width: 1.125rem

.row-teaser
  .details-button,
  .add-to-cart
    margin-top: 0.8rem
    display: none
    @screen md
      display: inline-block

a:hover
  z-index: 2
  position: relative
  .details-button,
  .add-to-cart
    opacity: 1
    transform: scale(1)
  .tile-teaser, .card-teaser, .row-teaser
    &:after
      box-shadow: 0 10px 50px -10px rgba(0, 0, 0, 0.2), 0 40px 80px 0 rgba(0, 0, 0, 0.05)
  .tile-teaser, .card-teaser
    transform: scale(1.02)
  .row-teaser
    transform: scale(1.01)
    background-color: theme('colors.gray.50')

// all cards same height
.horizontal .product-teaser
  min-height: 100%
  display: flex
  .card-teaser
    grid-template-rows: max-content auto

.strikethrough
  font-size: 0.8em
  opacity: 0.6
  color: $black
  &:before
    border-color: theme('colors.gray.700')

.price
  position: relative
.price nobr + nobr.sale
  margin-left: 1rem
  color: theme('colors.red.600')
  position: relative
  z-index: 1
  &:before
    content: ''
    position: absolute
    // background-color: theme('colors.red.100')
    background-color: #e6ff15
    width: calc(100% + 8px)
    height: calc(100% + 4px)
    left: -4px
    top: -7px
    z-index: -1
    transform: rotate(-9deg) skew(-2deg, 0deg)
</style>
